import styles from './input-currency.module.scss'

interface IInputCurrencyProps extends React.InputHTMLAttributes<HTMLInputElement> {
    ref?: React.Ref<HTMLInputElement>
    watch: string
}

const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>): void => {
    if (
        !/\d/.test(event.key) &&
        event.key !== 'Backspace' &&
        event.key !== '.' &&
        event.key !== ','
    ) {
        event.preventDefault()
    }
}

export const InputCurrency = ({ watch, ref, ...props }: IInputCurrencyProps): React.ReactNode => {
    return (
        <div className={styles['input-currency']}>
            <input
                ref={ref}
                className={styles['input-currency__value']}
                {...props}
                inputMode='numeric'
                type='text'
                onKeyDown={(event) => handleKeyDown(event)}
            />
            <span
                className={styles['input-currency__currency']}
                style={{
                    transform: `translateX(${20 + 13.7 * String(watch).length}px)`,
                }}
            >
                ₽
            </span>
        </div>
    )
}
